import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class FacebookActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.FACEBOOKACTION, apiHelper);
  }

  public loadCampaigns(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/campaigns?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }
}
